<template>
    <el-dialog
        :visible="show"
        :title="$t('PAGE_CLIENTUSER_EMAIL')"
        :close-on-click-modal="false"
        append-to-body
        @close="onDialogClose">
        <div class="sas-noticeemail-container">
            <div class="row">
                <div class="label">{{ $t('recevier') }}：</div>
                <el-select class="select" size="mini" v-model="emails" multiple collapse-tags :disabled="loading">
                    <el-option
                        v-for="(v, k) in emailOptions"
                        :key="k"
                        :label="v.userName"
                        :value="v.id"
                    ></el-option>
                </el-select>
            </div>
            <div class="row">
                <div class="label">{{ $t('ccer') }}：</div>
                <el-select class="select" size="mini" v-model="ccs" multiple collapse-tags :disabled="loading">
                    <el-option
                        v-for="(v, k) in ccOptions"
                        :key="k"
                        :label="v.userName"
                        :value="v.id"
                    ></el-option>
                </el-select>
            </div>
        </div>
        <template #footer>
            <div class="noticeemail-footer">
                <el-button class="cancel-btn" @click="onCancel" :loading="loading">{{ $t('comment_reSet') }}</el-button>
                <el-button class="cancel-btn" @click="e => onConfirm(true)" :loading="loading">{{ $t('send_me_a_preview') }}</el-button>
                <el-button type="primary" class="wl-green" @click="e => onConfirm(false)" :loading="loading">{{ $t('comment_send') }}</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'

export default {
    name: 'SASEmail',
    data() {return {
        emailOptions: [],
        ccOptions: [],
        emails: [],
        ccs: [],
        loading: false
    }},
    props: {
        selectList: [],
        show: {
            type: Boolean,
            default: false
        },
        statuId: {
            type: String,
            default: ''
        },
        reloadParents: {
            type: Function,
            default: () => {}
        },
        mode: String
    },
    mounted() {
        this.getOptions()
    },
    methods: {
        onCancel() {
            this.$emit('update:show', false)
        },
        onConfirm(myself = false) {
            if (!myself && this.emails.length  == 0) {
                this.$message.error(this.$t('please_choose_recevier'))
                return
            }
            this.loading = true
            let params = {
                statutoryBOList: this.selectList.map(v => ({
                    id: v.id,
                    entityName: v.entityName
                })),
                siteId: this.getSite.siteId,
                emailType: {
                    send_email_progress: 'statutoryProgress',
                    send_email_draft: 'statutoryReportUploaded'
                }[this.mode]
            }
            if (myself) {
                params.sendUserIdList = ['myself']
                params.ccUserIdList = []
            } else {
                params.sendUserIdList = this.emails
                params.ccUserIdList = this.ccs
            }
            API.status.clientStatAccStateSendEmail(params).then(res => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.$emit('update:show', false)
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).catch(e => {
                this.$message.error(this.$t('SYS_USER_003'))
            }).finally(() => {
                this.loading = false
            })
        },
        getOptions() {
            API.exchange.queryClientUserList({ siteId: this.getSite.siteId }).then(res => {
                this.emailOptions = res.data
            })
            API.status.queryKPMemberBySite({ siteId: this.getSite.siteId, userType: '1' }).then(res => {
                this.ccOptions = res.data
            })
        },
        onDialogClose() {
            this.$emit('update:show', false)
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds'
        })
    },
    watch: {
        show() {
            this.emails = []
            this.ccs = []
        }
    }
}
</script>
<style scoped>
.sas-noticeemail-container {
    width: 100%;
    display: flex;
    flex-direction: column;
}
.sas-noticeemail-container .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 50px;
    margin-bottom: 20px;
}
.sas-noticeemail-container .row .label {
    width: 200px;
}
.sas-noticeemail-container .row .select {
    width: 200px;
}
</style>